<!-- breadcrumb -->
<div class="container marginMobile">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    Produits&nbsp;>&nbsp;{{productF1?.titre}}&nbsp;>&nbsp;{{productF2?.titre}}&nbsp;>&nbsp; {{productF3}}
  </div>
</div>
<!-- Fin breadcrumb -->
<div class="container">
  <div class="row">
    <div class="col-sm-6">
      <div class="activeImg" style="background-image:url('{{baseUrl}}//{{product?.details.VIG}}')"></div>
    </div>
    <div class="col-sm-1">
      <!-- empty -->
    </div>
    <div class="col-sm-5">
      <h2 class="titreProduit">{{product?.details.ITMDES1}}</h2>
      <!-- <div *ngIf="!typeCompte"  class="prixProduit">
        <span class="lePrix">{{product?.details.MONTANT}}</span> <span class="Devise">Dhs</span>
      </div>
      <div *ngIf="typeCompte == 'B2C'"  class="prixProduit">
        <span  class="lePrix">{{product?.details.MONTANT}}</span> <span class="Devise">Dhs</span>
      </div>
      <div *ngIf="typeCompte == 'B2B'" class="prixProduit">
        <span class="lePrix">{{product?.details.PRIXNET}}</span> <span class="Devise">Dhs</span>
      </div> -->
      <div class="desProduit" [innerHTML]="product?.produit.TIT1_2.TEXTE">

      </div>
      <div class="row g-2 actionRow">
        <div class="col-12 ficheTechnique">
          <a href="http://102.53.9.162/ceratube/assets/images/DESCRIPTIF/{{product?.details.ITMREF}}.pdf" target="_blank" download><button type="button" name="button" class="ficheBtn"> <i class="fa fa-download" aria-hidden="true"></i> Telecharger la fiche technique</button></a>
        </div>
        <div class="col-12 col-xl-12 col-xxl-2 col-md- mb-3 qteBloc">
         <span class="qte">Qté : </span><input type="number" id="quantity" step="{{product.details.DET}}" [(ngModel)]="qte" (change)="changeQte()" name="quantity" min="{{product.details.DET}}" max="100">
        </div>
        <div class="col-12 col-lg-6 col-xl-6 col-xxl-5 m-0">
          <button class="btn actionBtn" [disabled]="product?.details.PHYSTO==0" (click)="addToCard(product)" name="button" data-bs-toggle="modal" data-bs-target="#exampleModal"><i class="fa fa-shopping-cart" aria-hidden="true"></i>
Ajouter au panier</button>
        </div>
        <div class="col-12 col-lg-6 col-xl-6 col-xxl-5 m-0" >
          <button class="btn actionBtn" (click)="addToFavoris(product)" name="button" *ngIf="!existFavoris"><i class="fa fa-heart" aria-hidden="true" ></i>
Ajouter aux favoris</button>
<button class="btn actionBtn" (click)="addToFavoris(product)" name="button" *ngIf="existFavoris" disabled><i class="fa fa-heart" aria-hidden="true"  ></i>
Ajouter aux favoris</button>
        </div>
      </div>
      <!-- Modal -->

      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl popUp modal-dialog-centered">
          <div class="closeBtn"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6"><p class="messageAddtocart">Produit ajouté avec succès à votre panier.</p></div>
                <!-- <div class="col-sm-6"><p class="messageStock">Il y a 2 articles dans votre panier</p></div> -->
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <img onerror="this.onerror=null;this.src='assets/front/images/logo.png';" src="{{baseUrl}}//{{product?.details.VIG}}" class="modalImage">
                </div>
                <div class="col-sm-4">
                  <h4 class="titreProduitModal">{{product?.details.ITMDES1}}</h4>
                  <p class="priceModal"><strong>{{product?.details.PRIXNET}}</strong> MAD</p>
                  <p class="qteModal">Qté : {{qte}}</p>
                </div>
                <div class="col-sm-6">
                  <p class="priceTotalModal">{{product?.details.PRIXNET}} MAD</p>
                <a routerLink="/panier">
                    <button class="btn actionBtn btnModal" name="button" data-bs-dismiss="modal"><i class="fa fa-shopping-cart" aria-hidden="true"></i>
                        Voir le panier</button>
                </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--End  Modal -->
      <div class="row">
        <div class="col-6 caracterName">
          <ul class="simpleList fw-bold">
            <!-- <li>Catégorie :</li> -->
            <li>Disponibilité :</li>
            <li>Référence :</li>
            <li>Fournisseur :</li>
          </ul>
        </div>
        <div class="col-6 caracterData">
          <ul class="simpleList">
            <!-- <li>Aeration, ventilation et isolation</li> -->
            <li><span class="enStock" *ngIf="product?.details.PHYSTO!=0;">En stock</span>  <span class="outOfStock" *ngIf="product?.details.PHYSTO==0;">En rupture de Stock</span></li>
            <li>{{product?.details.ITMREF}}</li>
            <li>{{fournisseur}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Produit similaire -->
<div class="container">
  <div class="row lesNouveautes">
        <div class="col-sm-12 sousTitreRubrique text-center" >
           Produits Similaires
           <div class="separTitres"></div>
        </div>
        <div class="col-sm-3 ProductBundle" *ngFor="let product of similarProducts?.slice(0, 4);">
           <app-card-product [product]="product" ></app-card-product>
        </div>
  </div>
</div>
<div class="progress-bar" [ngStyle]="{'width' : progress + '%' }"></div>
<!-- Fin Produit similaire -->
